var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocial(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4484 15.3184C21.0467 16.4034 22.1667 17.8734 22.1667 19.8334V23.3334H26.8334V19.8334C26.8334 17.29 22.6684 15.785 19.4484 15.3184Z",
    fill: "#7A51AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 14.0001C13.0774 14.0001 15.1667 11.9107 15.1667 9.33342C15.1667 6.75609 13.0774 4.66675 10.5 4.66675C7.92271 4.66675 5.83337 6.75609 5.83337 9.33342C5.83337 11.9107 7.92271 14.0001 10.5 14.0001Z",
    fill: "#7A51AE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 14.0001C20.0783 14.0001 22.1666 11.9117 22.1666 9.33342C22.1666 6.75508 20.0783 4.66675 17.5 4.66675C16.9516 4.66675 16.4383 4.78341 15.9483 4.94675C16.9522 6.18833 17.4999 7.73672 17.4999 9.33342C17.4999 10.9301 16.9522 12.4785 15.9483 13.7201C16.4383 13.8834 16.9516 14.0001 17.5 14.0001ZM10.5 15.1667C7.38496 15.1667 1.16663 16.7301 1.16663 19.8334V23.3334H19.8333V19.8334C19.8333 16.7301 13.615 15.1667 10.5 15.1667Z",
    fill: "#7A51AE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial);
export default __webpack_public_path__ + "static/media/social.80d1ff34fb677f9211b50e9e01d1f5fc.svg";
export { ForwardRef as ReactComponent };